export const GCLID_PARAM = "gclid";
export const GBRAID_PARAM = "gbraid";
export const WBRAID_PARAM = "wbraid";

export const CLICK_ID_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
